module.exports = __webpack_public_path__ + "static/media/DSC_0171.9b65c292.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0171.jpg
// module id = 692
// module chunks = 0